
import { PropTypes } from 'prop-types';
const VacanciesSection = ({ title, paragraphs }) => {
    return (
        <>
            <h1 className="text-4xl font-bold text-center  text-slate-900">{title}</h1>
            {
                paragraphs
            }
            {/* <div className="grid gap-4">
                {paragraphs.map((paragraph, index) => (
                    <p key={index} className="text-slate-900 font-normal">{paragraph}</p>
                ))}
            </div> */}
        </>
    )
}
VacanciesSection.propTypes = {
    title: PropTypes.string.isRequired,
    paragraphs: PropTypes.array.isRequired
}
export default VacanciesSection